module.exports = __webpack_public_path__ + "img/moon.3bc3561e.svg";